import React from "react";
import { useTranslation } from "react-i18next";
import { Container, Row, Col } from "shards-react";
import PageTitle from "../../../../components/commons/PageTitle";
import { modules } from "../../../modulesContent";
import { DashboardCard } from "../../components/card/DashboardCard";

const UMMHome = () => {
  const {t}=useTranslation()
  return (
    <Container fluid className="main-content-container px-4">
      <Row noGutters className="page-header py-4">
        <PageTitle
          title="Total de Utilizadores por Módulo"
          className="text-sm-left mb-3"
        />
      </Row>

      <Row className="mt-3 d-flex justify-content-center">
        {modules.map((module, idx) => (
          <Col className="col-lg-6 mb-4" key={idx}>
            <DashboardCard
              shortName={module.shortName}
              bgColor={module.bgColor}
              icone={module.icon}
              label={t(module.route)}
            />
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default UMMHome;
